import * as React from 'react'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { ThemeProvider } from '@mui/material/styles'

import { login, resetPwdEmail, useAuth } from './Firebase'
import { useLocation } from 'wouter'
import {
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormHelperText,
} from '@mui/material'
import { theme } from './Components/InternalThemeProvider'

function PasswordReset() {
  const [location, setLocation] = useLocation()
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState('')

  const currentUser = useAuth()
  if (currentUser != undefined) {
    setLocation('/')
  }

  async function handleSubmit(event) {
    event.preventDefault()
    const data = new FormData(event.currentTarget)
    if (data.get('email') === '') {
      setError('Fill in email address.')
    } else {
      try {
        await resetPwdEmail(data.get('email'))
        handleClickOpen();
      } catch (error) {
        setError('Email could not be sent.')
      }
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
  };
  
  // Close Dialog function
  const handleClose = () => {
    setOpen(false);
    setLocation('/Login')
  };

  document.title = 'TBIS service | Login'

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container
        component="main"
        maxWidth="100%"
        className="home-layout"
        sx={{
          background: 'rgb(255,255,255)',
          background:
            'linear-gradient(225deg, rgba(0,0,0,1) 0%, rgba(230,30,30,1) 50%, rgba(255,255,255,1) 100%)',
          mx: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '75vh',
        }}
      >
        <Card sx={{ maxWidth: 400 }}>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography component="h1" variant="h4" sx={{ mb: 2 }}>
                Reset password
              </Typography>
              <Typography component="p" variant="p">
                Please enter your email address to recieve an email to reset
                your password.
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  sx={{ width: 368 }}
                />
                {error && <FormHelperText error>{error}</FormHelperText>}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3 }}
                >
                  Reset Password
                </Button>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setLocation('/Login')
                  }}
                  sx={{ mt: 1, mb: 2 }}
                >
                  Back to login
                </Button>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Password Reset'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Password reset email sent successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  )
}

export default PasswordReset
